/* Preview stub — generated for the KCC branding live-preview lift of Studies + TopNavbar.
   No backend in this app; these inert modules satisfy the lifted components' imports. */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
 "selectedTheme": null,
 "selectedThemeName": ""
};

const sliceObj = createSlice({
	name: "themeManagement",
	initialState,
	reducers: {
		setSelectedTheme: (_state, _action: PayloadAction<any>) => {},
		setSelectedThemeName: (_state, _action: PayloadAction<any>) => {},
	},
});

export const { setSelectedTheme, setSelectedThemeName } = sliceObj.actions;
export default sliceObj.reducer;
